import { mutationTree } from 'typed-vuex';
import { AuthResponse } from '@/store/modules/auth/types';
import initialState from './state';

export default mutationTree(initialState, {
  AUTH_SUCCESS(state, { token }: AuthResponse) {
    state.token = token;
  },

  LOGOUT_CLEAR_STATE(state) {
    state.token = '';
  },
});
